/**
 * @flow
 * @relayHash edad1a2b7fb9286fc55bddd464c3f143
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProposalCreatorModal_organization$ref = any;
export type ProposalCreatorQueryVariables = {|
  orgDatabaseId: string,
  tensionDatabaseId: string,
|};
export type ProposalCreatorQueryResponse = {|
  +organization: ?{|
    +tension: ?{|
      +circle: ?{|
        +databaseId: string
      |}
    |},
    +$fragmentRefs: ProposalCreatorModal_organization$ref,
  |}
|};
export type ProposalCreatorQuery = {|
  variables: ProposalCreatorQueryVariables,
  response: ProposalCreatorQueryResponse,
|};
*/


/*
query ProposalCreatorQuery(
  $orgDatabaseId: String!
  $tensionDatabaseId: String!
) {
  organization(databaseId: $orgDatabaseId) {
    ...ProposalCreatorModal_organization
    tension(databaseId: $tensionDatabaseId) {
      circle {
        databaseId
        id
      }
      id
    }
    id
  }
}

fragment Accountabilities_organization on Organization {
  accountabilitiesLabel: termFor(name: "accountabilities")
  accountatibilityCheckingIsEnabled
  databaseId
  locale
  ...WYSIWYGTextareaWithFeatureFlag_organization
}

fragment Builder_organization on Organization {
  databaseId
  isAiEnabled
  ...ChangeList_organization
  ...TensionEditor_organization
}

fragment ChangeList_organization on Organization {
  ...Role_organization
  ...LinkedRole_organization
  ...Policy_organization
}

fragment CirclePicker_viewer on Person {
  circles(first: 100) {
    edges {
      node {
        viewerCanCreateProposal
        isGovernanceEnabled
        ...CircleSelector_circles
        id
      }
    }
  }
}

fragment CircleSelector_circles on Circle {
  id
  databaseId
  localizedName
  isGovernanceEnabled
  supportedRole {
    isDisplayedAsCircle
    id
  }
}

fragment Editor_organization on Organization {
  databaseId
  domainsLabel: termFor(name: "domains")
  purposeLabel: termFor(name: "purpose")
  showAccountabilities: featureEnabled(name: "accountabilities")
  showDomains: featureEnabled(name: "domains")
  showPurpose: featureEnabled(name: "purpose")
  roleTemplates(first: 100) {
    edges {
      node {
        id
      }
    }
  }
  ...RoleTemplateSelector_organization
  ...Accountabilities_organization
  ...WYSIWYGTextareaWithFeatureFlag_organization
}

fragment LinkedRole_organization on Organization {
  databaseId
  domainsLabel: termFor(name: "domains")
  purposeLabel: termFor(name: "purpose")
  ...Accountabilities_organization
  ...WYSIWYGTextareaWithFeatureFlag_organization
}

fragment Policy_organization on Organization {
  databaseId
  ...WYSIWYGTextareaWithFeatureFlag_organization
}

fragment ProposalCreatorBody_organization on Organization {
  ...Builder_organization
}

fragment ProposalCreatorBody_viewer on Person {
  ...CirclePicker_viewer
}

fragment ProposalCreatorModal_organization on Organization {
  databaseId
  ...ProposalCreatorBody_organization
  viewer {
    databaseId
    ...ProposalCreatorBody_viewer
    id
  }
}

fragment RoleTemplateSelector_organization on Organization {
  onRestrictedPlan
  roleTemplates(first: 100) {
    edges {
      node {
        databaseId
        name
        purpose
        domains
        accountabilities
        id
      }
    }
  }
}

fragment Role_organization on Organization {
  ...Editor_organization
}

fragment TensionBodyInput_organization on Organization {
  databaseId
  ...WYSIWYGTextareaWithFeatureFlag_organization
}

fragment TensionEditor_organization on Organization {
  databaseId
  ...TensionBodyInput_organization
}

fragment WYSIWYGTextareaWithFeatureFlag_organization on Organization {
  databaseId
  isWysiwygEnabled
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgDatabaseId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tensionDatabaseId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "databaseId",
    "variableName": "orgDatabaseId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "databaseId",
    "variableName": "tensionDatabaseId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "domains"
  }
],
v5 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "purpose"
  }
],
v6 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "accountabilities"
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProposalCreatorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Tension",
            "kind": "LinkedField",
            "name": "tension",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Circle",
                "kind": "LinkedField",
                "name": "circle",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProposalCreatorModal_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProposalCreatorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAiEnabled",
            "storageKey": null
          },
          {
            "alias": "domainsLabel",
            "args": (v4/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"domains\")"
          },
          {
            "alias": "purposeLabel",
            "args": (v5/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"purpose\")"
          },
          {
            "alias": "showAccountabilities",
            "args": (v6/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"accountabilities\")"
          },
          {
            "alias": "showDomains",
            "args": (v4/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"domains\")"
          },
          {
            "alias": "showPurpose",
            "args": (v5/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"purpose\")"
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "RoleTemplateConnection",
            "kind": "LinkedField",
            "name": "roleTemplates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleTemplateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTemplate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "purpose",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "domains",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountabilities",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "roleTemplates(first:100)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "onRestrictedPlan",
            "storageKey": null
          },
          {
            "alias": "accountabilitiesLabel",
            "args": (v6/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"accountabilities\")"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountatibilityCheckingIsEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isWysiwygEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "CircleConnection",
                "kind": "LinkedField",
                "name": "circles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CircleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Circle",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewerCanCreateProposal",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isGovernanceEnabled",
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "localizedName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "supportedRole",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isDisplayedAsCircle",
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "circles(first:100)"
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Tension",
            "kind": "LinkedField",
            "name": "tension",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Circle",
                "kind": "LinkedField",
                "name": "circle",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "edad1a2b7fb9286fc55bddd464c3f143",
    "metadata": {},
    "name": "ProposalCreatorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '09618a2ee1bb6c8f96bb166ccac945b1';

module.exports = node;
